import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { openDialog, closeDialog } from "orion-components/AppState/Actions";
import { AlertRhombus } from "mdi-material-ui";
import { DuressExitModal } from "../../Modals";
import PropTypes from "prop-types";
import { getTranslation } from "orion-components/i18n";

const styles = {
	listItem: dir => ({
		display: "flex",
		width: "100%",
		height: 50,
		position: "relative",
		color: "white",
		cursor: "pointer",
		backgroundColor: "#D3615C",
		...(dir === "ltr" && { paddingLeft: 50 }),
		...(dir === "rtl" && { paddingRight: 50 })
	}),
	iconButton: {
		color: "white",
		minWidth: 40
	},
	text: {
		fontSize: 12,
		display: "flex"
	}
};

const DuressActivated = ({ dir, setInProgress }) => {
	const dispatch = useDispatch();
	const dialog = useSelector(state => state.appState.dialog.openDialog);

	const handleDuressExit = useCallback(() => {
		setInProgress(true);
		dispatch(openDialog("duressExit"));
	}, [dispatch, setInProgress]);

	const handleDuressReset = useCallback(() => {
		setInProgress(false);
		dispatch(closeDialog("duressExit"));
	}, [dispatch, setInProgress]);

	return (
		<>
			<ListItem
				style={styles.listItem(dir)}
				onClick={handleDuressExit}
				role="button"
				tabIndex={0}
				aria-label="Workstation Duress Activated - Click to exit duress mode"
				onKeyDown={e => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						handleDuressExit();
					}
				}}
				data-testid="settings-app-src-shared-components-side-navigation-components-duress-activated-list-item"
			>
				<ListItemIcon style={styles.iconButton}>
					<AlertRhombus style={{ height: 20, width: 20 }} />
				</ListItemIcon>
				<ListItemText
					primary={getTranslation("sideBar.duressActivated")}
					primaryTypographyProps={{
						className: "b1-white",
						style: styles.text
					}}
				/>
			</ListItem>
			<DuressExitModal open={dialog === "duressExit"} handleClose={handleDuressReset} />
		</>
	);
};

DuressActivated.propTypes = {
	dir: PropTypes.oneOf(["ltr", "rtl"]).isRequired,
	setInProgress: PropTypes.func.isRequired
};

export default DuressActivated;
